import { render } from "./AdminNavComponent.vue?vue&type=template&id=4e647a48"
import script from "./AdminNavComponent.vue?vue&type=script&lang=js"
export * from "./AdminNavComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__